export default "__VITE_ASSET__Cd$kyIyF__"